import { currentLocale } from "@/composables/useLanguages";

const COPY = {
  ro: {
    brand: "Veridian",
    nav_numbers: "Numere", nav_sims: "SIM-uri", nav_add: "Adaugă", nav_port: "Portări",
    logout: "Ieși", profile: "Profil",
    soon: "în curând",
    // number card
    active: "Activ", in_air: "În aer", on_sim: "Pe SIM", credit: "Credit",
    valid_until: "valabil până", services: "Servicii", signal_only: "doar semnal",
    topup: "Reîncarcă", add_service: "Adaugă serviciu", move_to_sim: "Mută pe SIM",
    activate_on_sim: "Activează pe un SIM",
    // sim card
    number_now: "Număr acum", no_number: "Niciun număr activ", change_number: "Schimbă numărul",
    details: "Detalii", activate_number: "Activează un număr", empty: "Gol",
    // my numbers
    numbers_title: "Numerele mele", buy_number: "Cumpără număr",
    numbers_empty: "Nu ai încă niciun număr.",
    // my sims
    sims_title: "SIM-urile mele", buy_sim: "Cumpără SIM",
    sims_empty: "Nu ai încă niciun SIM.",
    // add number
    add_title: "Adaugă numărul meu",
    add_intro: "Ai un număr în altă rețea? Adu-l la Veridian prin portare ca să beneficiezi de servicii.",
    add_btn: "Adaugă număr", add_my_list: "Numerele mele adăugate",
    request_port: "Cere portare", add_empty: "Niciun număr adăugat încă.",
    // port status
    port_title: "Portările mele", port_empty: "Nicio cerere de portare.",
    port_created: "creată", port_status: "Status",
    loading: "Se încarcă...",
  },
  en: {
    brand: "Veridian",
    nav_numbers: "Numbers", nav_sims: "SIMs", nav_add: "Add", nav_port: "Porting",
    logout: "Sign out", profile: "Profile",
    soon: "soon",
    active: "Active", in_air: "In the air", on_sim: "On SIM", credit: "Credit",
    valid_until: "valid until", services: "Services", signal_only: "signal only",
    topup: "Top up", add_service: "Add service", move_to_sim: "Move to SIM",
    activate_on_sim: "Activate on a SIM",
    number_now: "Number now", no_number: "No active number", change_number: "Change number",
    details: "Details", activate_number: "Activate a number", empty: "Empty",
    numbers_title: "My numbers", buy_number: "Buy number",
    numbers_empty: "You don't have any number yet.",
    sims_title: "My SIMs", buy_sim: "Buy SIM",
    sims_empty: "You don't have any SIM yet.",
    add_title: "Add my number",
    add_intro: "Got a number on another network? Bring it to Veridian via porting to get services.",
    add_btn: "Add number", add_my_list: "My added numbers",
    request_port: "Request porting", add_empty: "No number added yet.",
    port_title: "My porting requests", port_empty: "No porting request.",
    port_created: "created", port_status: "Status",
    loading: "Loading...",
  },
};

export function cc() {
  return COPY[currentLocale.value === 'en' ? 'en' : 'ro'];
}
